export const images = [
  {
    id: 1,
    originalTitle: "Importnant Pic for Abdur Rab Hall",
    thumbnailTitle: "Importnant Pic for Abdur Rab Hall",
    thumbnailAlt: "This is an important pic of abdur rab hall",
    description: "This is an important pic of abdur rab hall",
    original:
      "https://i.ibb.co/9vpw6Yj/thumb-gallery-137-1560317958-ZH6-M9-V225-N.png",
    thumbnail:
      "https://i.ibb.co/9vpw6Yj/thumb-gallery-137-1560317958-ZH6-M9-V225-N.png",
    uploadDate: "2022-01-22",
    category: {
      institutional: false,
      hall: true,
    },
  },
  {
    id: 4,
    originalTitle: "Importnant Pic for Abdur Rab Hall",
    thumbnailTitle: "Importnant Pic for Abdur Rab Hall",
    thumbnailAlt: "This is an important pic of abdur rab hall",
    description: "This is an important pic of abdur rab hall",
    original:
      "https://i.ibb.co/Hd03bY4/thumb-gallery-137-1560317782-OCGL8-BFT32.png",
    thumbnail:
      "https://i.ibb.co/Hd03bY4/thumb-gallery-137-1560317782-OCGL8-BFT32.png",
    uploadDate: "2022-01-22",
    category: {
      institutional: false,
      hall: true,
    },
  },
  {
    id: 5,
    originalTitle: "Importnant Pic for Abdur Rab Hall",
    thumbnailTitle: "Importnant Pic for Abdur Rab Hall",
    thumbnailAlt: "This is an important pic of abdur rab hall",
    description: "This is an important pic of abdur rab hall",
    original:
      "https://i.ibb.co/Gx2JSLQ/thumb-gallery-137-1560317732-6-KACW4-YB3-Q.png",
    thumbnail:
      "https://i.ibb.co/Gx2JSLQ/thumb-gallery-137-1560317732-6-KACW4-YB3-Q.png",
    uploadDate: "2022-01-22",
    category: {
      institutional: false,
      hall: true,
    },
  },
  {
    id: 6,
    originalTitle: "Importnant Pic for Abdur Rab Hall",
    thumbnailTitle: "Importnant Pic for Abdur Rab Hall",
    thumbnailAlt: "This is an important pic of abdur rab hall",
    description: "This is an important pic of abdur rab hall",
    original: "https://i.ibb.co/2dLjd6D/gallery-137-1560317806-DU2-KYLVA6-S.jpg",
    thumbnail: "https://i.ibb.co/2dLjd6D/gallery-137-1560317806-DU2-KYLVA6-S.jpg",
    uploadDate: "12-8-21",
    category: {
      institutional: true,
      hall: false,
    },
  },
  {
    id: 2,
    originalTitle: "Importnant Pic for Abdur Rab Hall",
    thumbnailTitle: "Importnant Pic for Abdur Rab Hall",
    thumbnailAlt: "This is an important pic of abdur rab hall",
    description: "This is an important pic of abdur rab hall",
    original: "https://i.ibb.co/0M0qW9M/1584040477-8.jpg",
    thumbnail: "https://i.ibb.co/0M0qW9M/1584040477-8.jpg",
    uploadDate: "12-8-21",
    category: {
      institutional: true,
      hall: false,
    },
  },
  {
    id: 3,
    originalTitle: "Importnant Pic for Abdur Rab Hall",
    thumbnailTitle: "Importnant Pic for Abdur Rab Hall",
    thumbnailAlt: "This is an important pic of abdur rab hall",
    description: "This is an important pic of abdur rab hall",
    original: "https://i.ibb.co/8BwzSWc/IMG-20210521-221907.jpg",
    thumbnail: "https://i.ibb.co/8BwzSWc/IMG-20210521-221907.jpg",
    uploadDate: "12-8-21",
    category: {
      institutional: true,
      hall: false,
    },
  },
];
